import './butfly';

import {WsChat, UserStatus, WsChatEvents} from '@iassasin/wschatapi';
import Room from './room';

import Settings from './settings';
import UserActivity from './useractivity';
import eventBus from '../eventbus';
import {preprocessSysMessage} from './messagepreprocessor';

let Chat = {
	/** @type WsChat */
	wschat: null,
	address: 'wss://sinair.net/ws/chat',

	syscolor1: 'gold',
	syscolor2: 'skyblue',

	/** @type Room[] */
	rooms: [],
	curRoom: null,

	_reconnectTimer: null,
	connectionToken: null,

	init(){
		this.initMessageInput();
		this.initToolsButtons();
		this.initRoomsList();

		UserActivity.onUserActivityChanged.on((active) => {
			this.onAwayStatusChanged(!active);
		});
	},

	renewSession() {
		let baseHost = location.host.split('.').slice(1).join('.');
		fetch(`${location.protocol}//${baseHost}/fapi/profile`, {credentials: 'include'}).catch(console.error);
	},

	initMessageInput(){
		eventBus.$on('sendMessage', (message) => {
			if (message.match(/[^\s]/) != null){
				if (this.send(message)){
					eventBus.state.messageText = '';
					eventBus.$emit('resetAutocompletion');
					this.setTyping(false);
				}
			}
		});

		eventBus.$on('typing', (state) => {
			this.setTyping(true);
		});
	},

	initToolsButtons(){
		eventBus.$on('createRoom', async (name) => {
			try {
				await this.wschat.createRoom(name);
				await this.joinRoom(name);
			} catch (err) {
				this.handleError(err);
			}
		});

		eventBus.$on('removeCurrentRoom', async () => {
			try {
				if (this.curRoom != null){
					await this.wschat.removeRoom(this.curRoom.wsroom.target);
				} else {
					alert('Текущая комната не выбрана!');
				}
			} catch (err) {
				this.handleError(err);
			}
		});
	},

	initRoomsList() {
		eventBus.$on('closeRoomTab', async (target) => {
			try {
				await this.leaveRoom(target);
			} catch (err) {
				this.handleError(err);
			}
		});

		eventBus.$on('selectRoom', (target) => {
			this.selectRoom(target);
		});

		eventBus.$on('joinRoom', async (target) => {
			try {
				await this.joinRoom(target);
			} catch (err) {
				this.handleError(err);
			}
		});
	},

	async connect() {
		try {
			if (this.wschat) {
				try { await this.wschat.close(); } catch {}
				this.wschat = null;
			}

			if (this._reconnectTimer) {
				clearTimeout(this._reconnectTimer);
				this._reconnectTimer = null;
			}

			let wschat = new WsChat(this.address);
			this.wschat = wschat;

			let joinRooms = async () => {
				if (this.rooms.length <= 0) {
					let rooms = Settings.lastState.rooms;
					if (rooms.length && rooms.length > 0) {
						await this.joinRooms(rooms);
					} else {
						await this.joinRoom('#chat');
					}
				} else {
					for (let room of this.rooms) {
						try {
							await this.joinRoom(room.wsroom.target);
						} catch (error) {
							this.handleError(err);
						}
					}
				}
			};

			wschat.on(WsChatEvents.open, async () => {
				try {
					this.renewSession();

					eventBus.state.connected = true;
					this.setTypingList([]);

					this.addSysMsg('Вы подключились к серверу');

					if (this.connectionToken) {
						let uinfo = await this.wschat.restoreConnection(this.connectionToken).catch(() => {});
						if (uinfo && uinfo.token === this.connectionToken) {
							eventBus.updateUser(uinfo);
							return;
						}
					}

					// auth by http header 'sinid'
					let uinfo = await this.wschat.authByKey(undefined).catch(() => {});
					if (uinfo) {
						eventBus.updateUser(uinfo);

						this.connectionToken = uinfo.token;
					}

					await joinRooms();
				} catch (err) {
					this.handleError(err);
				}
			});

			wschat.on(WsChatEvents.close, () => {
				if (eventBus.state.connected) {
					this.onDisconnected();
				}

				eventBus.state.connected = false;

				if (this._reconnectTimer) {
					clearTimeout(this._reconnectTimer);
				}

				this._reconnectTimer = setTimeout(this.connect.bind(this), 10000);
			});

			wschat.on(WsChatEvents.connectionError, (err) => {
				console.log(err);
			});

			wschat.on(WsChatEvents.error, this.handleError.bind(this));

			wschat.on(WsChatEvents.joinRoom, wsroom => {
				this.initRoom(wsroom);

				if (!this.curRoom) {
					this.selectRoom('');
				}
			});

			wschat.on(WsChatEvents.leaveRoom, (target) => {
				let room = this.getRoomByName(target);
				if (room) {
					this.onLeaveRoom(room);
				}
			});

			wschat.on(WsChatEvents.message, (wsroom, msg) => {
				let room = this.getRoomByName(wsroom.target);
				if (room) room.onMessage(msg);
			});

			wschat.on(WsChatEvents.sysMessage, (wsroom, text) => {
				if (!wsroom) {
					alert(text);
					return;
				}

				let room = this.getRoomByName(wsroom.target);
				if (room) room.onSysMessage(text);
			});

			wschat.on(WsChatEvents.userStatusChange, (wsroom, user) => {
				let room = this.getRoomByName(wsroom.target);
				if (room) room.onUserStatusChanged(user);
			});

			await wschat.open();
		} catch (err) {
			this.handleError(err);
		}
	},

	handleError(error) {
		console.log(error);

		if (error.info) {
			alert(error.info);
		} else if (error.message) {
			alert(error.message);
		} else if (!(error.target instanceof WebSocket)) {
			alert('Неизвестная ошибка при работе с чатом, обратитесь к разработчику');
		}
	},

	setOnlineList(members){
		eventBus.state.onlineList = members;
	},

	setMessages(room, messages){
		eventBus.$emit('setMessages', {room, messages});
	},

	setTypingList(list){
		eventBus.state.typingList = list;
	},

	send(msg){
		if (this.curRoom != null){
			if (msg == '/clear'){
				this.curRoom.clearMessages();
				this.setMessages(this.curRoom, this.curRoom.getMessages());
				this.curRoom.onSysMessage('Ваш чат был очищен');
				return true;
			}
			else if (msg.substr(0, 4) == '/re '){
				let mid = this.curRoom.getLastPMMemberId();
				if (mid){
					msg = '/umsg ' + mid + ' ' + msg.substr(4);
				} else {
					this.curRoom.onSysMessage('Вам еще никто не писал в ЛС');
					return false;
				}
			}

			if (msg[0] !== '/' && !this.curRoom.wsroom.memberNick) {
				alert('Введите ник, чтобы отправлять сообщения');
				return false;
			}

			msg = msg.replace(/^\/msg @/, '/msg ');

			this.curRoom.wsroom.sendMessage(msg);
			return true;
		}

		return false;
	},

	addSysMsg(msg){
		eventBus.$emit('addMessage', {
			room: null,
			message: {
				type: 'sysmessage',
				time: Date.now(),
				body: msg,
				processedBody: preprocessSysMessage(msg, null),
			},
		});
	},

	setTyping(val){
		if (Settings.typing && this.curRoom){
			this.curRoom.setTyping(val);
		}
	},

	firstRun(){
		Settings.save();
	},

	//rooms local

	async joinRooms(rooms) {
		for (let room of rooms) {
			try {
				await this.joinRoom(room);
			} catch (e) {
				console.log(`Error joining room '${room}'`, e);
			}
		}
	},

	getRoomByName(name){
		return this.rooms.find(x => x.wsroom.target == name) || null;
	},

	async joinRoom(target) {
		let wsroom = await this.wschat.joinRoom(target, {
			autoLogin: true,
			loadHistory: true,
		});

		let room = this.initRoom(wsroom);
		this.selectRoom(wsroom.target);

		return room;
	},

	removeRoom(room){
		this.removeRoomTab(room.wsroom.target);
		this.rooms = this.rooms.filter(el => el != room);
	},

	initRoom(wsroom) {
		let room = this.getRoomByName(wsroom.target);
		if (!room) {
			room = new Room(this, wsroom);
			this.rooms.push(room);
		}

		room.wsroom = wsroom;
		let tab = this.createRoomTab(room);
		room.onJoined();
		tab.joined = true;

		return room;
	},

	createRoomTab(room){
		let tabs = eventBus.state.roomTabs;
		let target = room.wsroom.target;

		let tab = tabs.find(x => x.target == target);
		if (!tab){
			tab = {
				target,
				name: target,
				unread: 0,
				joined: true,
			};

			tabs.push(tab);
		}

		Settings.lastState.rooms = tabs.map(x => x.target);
		Settings.save();

		return tab;
	},

	removeRoomTab(name){
		eventBus.state.roomTabs = eventBus.state.roomTabs.filter(x => x.target != name);

		Settings.lastState.rooms = eventBus.state.roomTabs.map(x => x.target);
		Settings.save();
	},

	selectRoom(name) {
		if (this.curRoom == null || this.curRoom.wsroom.target != name) {
			let room = null;
			if (name != '') {
				room = this.getRoomByName(name);
			} else if (this.rooms.length > 0){
				room = this.rooms[0];
			}

			if (room) {
				this.curRoom = room;
				eventBus.state.activeTab = room.wsroom.target;
				this.setMessages(room, room.getMessages());
				this.setOnlineList(room.getMembers());
				this.setTypingList(room.getTypingMembers());

				room.unread = 0;
				this.onUpdateUnread(room);
			}
		}
	},

	// rooms server

	async leaveRoom(name){
		let room = this.getRoomByName(name);
		if (room != null){
			this.onLeaveRoom(room);
		} else {
			this.removeRoomTab(name);
		}

		await this.wschat.leaveRoom(name);
	},

	//events

	onChatMessage(room, message){
		if (this.curRoom == room){
			eventBus.$emit('addMessage', {room, message});
		} else {
			++room.unread;
			this.onUpdateUnread(room);
		}
	},

	onOnlineListChanged(room, list){
		if (this.curRoom == room){
			this.setOnlineList(list);
		}
	},

	onTypingListChanged(room, list){
		if (this.curRoom == room){
			this.setTypingList(list);
		}
	},

	onLeaveRoom(room){
		this.removeRoom(room);

		if (this.curRoom.wsroom.target == room.wsroom.target){
			this.selectRoom('');
		}
	},

	onUpdateUnread(room){
		let tab = eventBus.state.roomTabs.find(x => x.target == room.wsroom.target);
		tab.unread = room.unread;
	},

	onAwayStatusChanged(isAway){
		if (this.wschat != null && this.wschat.connected) {
			this.wschat.changeStatus(isAway ? UserStatus.away : UserStatus.back);
		}
	},

	onDisconnected() {
		this.addSysMsg('Соединение с сервером было закрыто. Пытаюсь переподключиться...');

		for (let room of this.rooms) {
			room.onLeave();
		}

		for (let tab of eventBus.state.roomTabs) {
			tab.joined = false;
		}
	}
};

export default Chat;
